import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    questionCategory: {
      label: 'Category',
      placeholder: 'select ...',
    },
  },
}
